<template>
  <div>
    <div class="table-head">
        <h4>{{$t('vdog_addition_betting')}}</h4>
    </div>
    <div class="table-body">
        <!-- First row -->
        <div class="row">
            <div class="left-bet">
                <p>
                    {{$t('vdog_even')}} <span>{{format(extractStakeForDogTabeEvenOdd(1))}}</span>
                </p>
            </div>
            <div class="description">
                <p>
                    {{$t('vdog_winner_starting_no')}}
                    <br />
                    {{$t('vdog_even')}} {{$t('vdog_or')}} {{$t('vdog_odd')}}
                </p>
            </div>
            <div class="right-bet">
                <p>{{$t('vdog_odd')}} <span>{{format(extractStakeForDogTabeEvenOdd(0))}}</span></p>
            </div>
        </div>
        <!-- Second row -->
        <div class="row">
            <div class="left-bet">
                <p>
                    {{$t('vdog_low')}}
                    <span>{{format(extractStakeForDogTabeLowHigh(0))}}</span>
                </p>
            </div>
            <div class="description">
                <p>
                    {{$t('vdog_winner_starting_no')}}
                    <br />
                     {{$t('vdog_low')}} {{$t('vdog_or')}}  {{$t('vdog_high')}}
                </p>
            </div>
            <div class="right-bet">
                <p>
                    {{$t('vdog_high')}}
                    <span>{{format(extractStakeForDogTabeLowHigh(1))}}</span>
                </p>
            </div>
        </div>
        <!-- Third row -->
        <div class="row">
            <div class="left-bet">
                <p>
                    ({{$t('vdog_under')}} 7,5)
                    <br />
                    <span>{{format(extractStakeForDogTabeSum12(0))}}</span>
                </p>
            </div>
            <div class="description">
                <p>
                    {{$t('vdog_winner_runner_up')}}
                    <br />
                    {{$t('vdog_starting_no_sum')}}
                </p>
            </div>
            <div class="right-bet">
                <p>
                     ({{$t('vdog_over')}} 7,5)
                    <br />
                    <span>{{format(extractStakeForDogTabeSum12(1))}}</span>
                </p>
            </div>
        </div>
        <!-- Fourth row -->
        <div class="row">
            <div class="left-bet">
                <p>
                    ({{$t('vdog_under')}} 10,5)
                    <br />
                    <span>{{format(extractStakeForDogTabeSum123(0))}}</span>
                </p>
            </div>
            <div class="description">
                <p>
                    {{$t('vdog_first_three_dogs')}}
                    <br />
                    {{$t('vdog_starting_no_sum')}}
                </p>
            </div>
            <div class="right-bet">
                <p>
                    ({{$t('vdog_over')}} 10,5)
                    <br />
                    <span>{{format(extractStakeForDogTabeSum123(1))}}</span>
                </p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    match: {
      type: Object,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    },
    extractStakeForDogTabeEvenOdd (position) {
      if (this.match && this.match.tableOddEven &&
        this.match.tableOddEven.data &&
        this.match.tableOddEven.data[0] &&
        this.match.tableOddEven.data[0][position] &&
        this.match.tableOddEven.data[0][position].Factor) {
        return this.match.tableOddEven.data[0][position].Factor
      }
      return 0
    },
    extractStakeForDogTabeLowHigh (position) {
      if (this.match && this.match.tableLowHigh &&
        this.match.tableLowHigh.data &&
        this.match.tableLowHigh.data[0] &&
        this.match.tableLowHigh.data[0][position] &&
        this.match.tableLowHigh.data[0][position].Factor) {
        return this.match.tableLowHigh.data[0][position].Factor
      }
      return 0
    },
    extractStakeForDogTabeSum123 (position) {
      if (this.match && this.match.sumTable123 &&
        this.match.sumTable123.data &&
        this.match.sumTable123.data[0] &&
        this.match.sumTable123.data[0][position] &&
        this.match.sumTable123.data[0][position].Factor) {
        return this.match.sumTable123.data[0][position].Factor
      }
      return 0
    },
    extractStakeForDogTabeSum12 (position) {
      if (this.match && this.match.sumTable12 &&
        this.match.sumTable12.data &&
        this.match.sumTable12.data[0] &&
        this.match.sumTable12.data[0][position] &&
        this.match.sumTable12.data[0][position].Factor) {
        return this.match.sumTable12.data[0][position].Factor
      }
      return 0
    }
  }
}
</script>
